import { render, staticRenderFns } from "./TourTeaser.vue?vue&type=template&id=8f4daf92&lang=pug&"
import script from "./TourTeaser.vue?vue&type=script&lang=js&"
export * from "./TourTeaser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports